import axios from 'axios';

// Use environment variable for base URL (fallback to localhost:5002)
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5002';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
    });
    return Promise.reject(error);
  }
);

// Candidate Portal API
// 🔗 CANDIDATE PORTAL API - ENHANCED
// Candidate Portal API
export const candidatePortalAPI = {
  // Get active job postings for career portal
  getActiveJobs: async () => {
    try {
      console.log('📋 Fetching active jobs for candidate portal...');
      const response = await api.get('/candidates/portal/active-jobs');
      
      console.log('📊 Active jobs response:', {
        success: response.data.success,
        count: response.data.count,
        dataLength: response.data.data?.length || 0
      });
      
      return response;
    } catch (error) {
      console.error('❌ Failed to fetch active jobs:', error);
      throw error;
    }
  },

  // Get job details — backend returns { success, data: job }
  getJobDetails: async (id) => {
    const response = await api.get(`/job-postings/${id}`);
    return response;
  },
  
  // Submit job application
  submitApplication: (formData) => {
    return api.post('/candidates/apply', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    });
  },
  
  // Check for duplicate applications
  checkDuplicate: (email, phone) => 
    api.post('/candidates/check-duplicate', { email, phone }),
  
  // Test connection
  testConnection: () => api.get('/candidates/test/health'),
  
  // Debug endpoints
  debugCandidates: () => api.get('/candidates/debug/all-candidates'),
  debugJobs: () => api.get('/candidates/debug/job-postings')
};


export default api;
